// extracted by mini-css-extract-plugin
export default {"container":"send-ready-artwork_container__FrdZV","greenButton":"send-ready-artwork_greenButton__MHkSH"};